import { useEffect } from 'react';

interface MarketFitConfig {
  enabled?: boolean;
  accentColor?: string;
  position?: 'bottom-right' | 'bottom-left';
  title?: string;
  welcomeMessage?: string;
}

export const useMarketFitChat = (config?: MarketFitConfig) => {
  useEffect(() => {
    // Solo cargar si no existe ya
    if (window.MarketFit) return;
    // const id_commerce = localStorage.getItem('id_commerce');
    // const id_user = localStorage.getItem('id_user');
    // const id_path = localStorage.getItem('id_path');
    const email = localStorage.getItem('email');
    const commerce_name = (localStorage.getItem('commerce_name') || '').toString();
    const user_name = (localStorage.getItem('user_name') || '').toString();
    const userData = localStorage.getItem('userData');
    // console.log(userData);

    window.MarketFit = window.MarketFit || {};
    window.MarketFit.siteId = '16d322ab-3104-4935-b7cf-ada54c2a1bbb';

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://files.uncodie.com/tracking.min.js';

    script.onload = () => {
      if (window.MarketFit && typeof window.MarketFit.init === 'function') {
        window.MarketFit.init({
          siteId: '16d322ab-3104-4935-b7cf-ada54c2a1bbb',
          trackVisitors: true,
          trackActions: true,
          recordScreen: true,
          debug: false,
          chat: {
            enabled: config?.enabled ?? true,
            accentColor: config?.accentColor ?? '#e0ff17',
            allowAnonymousMessages: false,
            position: config?.position ?? 'bottom-right',
            title: config?.title ?? 'Chat de Soporte',
            welcomeMessage: config?.welcomeMessage ?? '¡Hola! ¿Cómo podemos ayudarte?',
          },
        });
        window.MarketFit.identify?.({
          name: commerce_name,
          user_name: user_name,
          email: email,
          userData,
        });
      }
    };

    document.head.appendChild(script);

    // Cleanup
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [config]);
};

// Interfaces para tipado de MarketFit
interface MarketFitChatConfig {
  enabled?: boolean;
  accentColor?: string;
  allowAnonymousMessages?: boolean;
  position?: 'bottom-right' | 'bottom-left';
  title?: string;
  welcomeMessage?: string;
}

interface MarketFitInitConfig {
  siteId: string;
  trackVisitors?: boolean;
  trackActions?: boolean;
  recordScreen?: boolean;
  debug?: boolean;
  chat?: MarketFitChatConfig;
}

interface MarketFitUserData {
  name?: string;
  user_name?: string;
  email?: string | null;
  userData?: string | null;
}

interface MarketFitInstance {
  siteId?: string;
  init?: (config: MarketFitInitConfig) => void;
  identify?: (data: MarketFitUserData) => void;
}

// Declara el tipo global para TypeScript
declare global {
  interface Window {
    MarketFit: MarketFitInstance;
  }
}
